<template>
  <ul
    class="flex w-full flex-row overflow-auto px-3.5 py-1 md:absolute md:-top-11"
    @mousedown="startDrag"
    @mousemove="onDrag"
    @mouseup="endDrag"
    @mouseleave="endDrag">
    <li
      v-for="(multiRoom, index) in multiRoomListC"
      :key="index"
      ref="roomRefs"
      class="mr-2 flex cursor-pointer items-center whitespace-nowrap rounded-gc-lg border border-dark bg-light py-1.5 pl-2 pr-5 text-xs text-dark"
      :class="[
        currentRoom == multiRoom.identifier ? '!bg-dark text-light' : '',
        multiRoom.selected ? 'cursor-pointer' : '',
      ]"
      @click="openRoom(index)">
      <i class="mr-1 flex h-5 min-w-4 max-w-5 items-center justify-center">
        <BedIcon v-if="!multiRoom.selected" class="h-auto w-full" />
        <CheckCircle v-else class="h-auto w-full text-success" />
      </i>
      <div>
        {{ $t('general.room') }}
        <span>{{ multiRoom.name }}</span>
      </div>
    </li>
  </ul>
</template>
<script setup>
import { computed, ref, onUpdated, onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import router from '@/router';
import { useRoute } from 'vue-router';
import { useOffersStore } from '@stores/offers.store';
import { useReservationStore } from '@stores/reservation.store';

import BedIcon from '@icons/bed_size.svg';
import CheckCircle from '@icons/check_circle.svg';

const route = useRoute();
const reservationStore = useReservationStore();
const { reservations } = storeToRefs(reservationStore);
const offersStore = useOffersStore();
const { currentRoom, multiRoomList, loadingSameRoom } =
  storeToRefs(offersStore);

const multiRoomListC = computed(() => {
  let parentRooms = {};
  let copy = JSON.parse(JSON.stringify(multiRoomList.value));
  let grouped = Object.values(copy).reduce((acc, room) => {
    if (room.parent !== undefined) {
      acc[room.parent] = room;
    }
    return acc;
  }, {});

  for (let i in copy) {
    if (copy[i].parent == undefined) {
      parentRooms[i] = copy[i];
      parentRooms[i].name = parseInt(copy[i].identifier) + 1;
    }
  }
  for (let ii in grouped) {
    parentRooms[grouped[ii].parent].name =
      parentRooms[grouped[ii].parent].name +
      ' - ' +
      (parseInt(grouped[ii].identifier) + 1);
  }
  return parentRooms;
});

const roomRefs = ref([]);

const isDragging = ref(false);
const startX = ref(0);
const scrollLeft = ref(0);
const ulRef = ref(null);

const startDrag = (e) => {
  isDragging.value = true;
  startX.value = e.pageX - ulRef.value.offsetLeft;
  scrollLeft.value = ulRef.value.scrollLeft;
};

const onDrag = (e) => {
  if (!isDragging.value) return;
  e.preventDefault();
  const x = e.pageX - ulRef.value.offsetLeft;
  const walk = (x - startX.value) * 2;
  ulRef.value.scrollLeft = scrollLeft.value - walk;
};

const endDrag = () => {
  isDragging.value = false;
};

const openRoom = (index) => {
  if (currentRoom.value == index) return;
  if (!multiRoomList.value[index].selected) return;
  Object.values(multiRoomList.value).forEach((reservation) => {
    if (reservation && reservation.update) {
      reservation.update = false;
    }
  });

  const lastReservationSelected = currentRoom.value;
  currentRoom.value = index;
  if (reservations.value[index]) {
    const queryRoomRateCode = route.params.id || '';
    if (
      (!reservations.value[lastReservationSelected] &&
        queryRoomRateCode ===
          reservations.value[index].roomRate.room_rate_code) ||
      (reservations.value[lastReservationSelected] &&
        reservations.value[lastReservationSelected].roomRate.room_rate_code ===
          reservations.value[index].roomRate.room_rate_code)
    ) {
      loadingSameRoom.value = true;
    }

    multiRoomList.value[index].update = true;
    const roomRateCode = reservations.value[index].roomRate.room_rate_code;
    router
      .push({
        name: 'extras',
        query: route.query,
        params: { id: roomRateCode },
      })
      .then(() => {
        loadingSameRoom.value = false;
        window.scrollTo(0, 0);
      });
  }
};

const scrollToCurrentRoom = () => {
  setTimeout(() => {
    const currentRoomElement = roomRefs.value[currentRoom.value];
    if (currentRoomElement) {
      currentRoomElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'end',
      });
    }
  }, 100);
};

onMounted(() => {
  ulRef.value = document.querySelector('ul');
  scrollToCurrentRoom();
});

onUpdated(() => {
  scrollToCurrentRoom();
});

onUnmounted(() => {
  ulRef.value = null;
});
</script>
